<template>
  <section class="find-friend">
    <header>
      <span class="back-btn" @click="Close"><img :src="require('../../assets/images/back-icon.svg')" alt=""></span>
    </header>
    <div class="find-content">
      <span class="pulse"><img :src="require('../../assets/images/group.svg')" alt=""></span>
    </div>
    <span class="text" v-if="!internetDisconnect">{{$t('Lookingfriends')}}</span>
    <span class="text" v-if="internetDisconnect">{{$t('Re-connecting')}}</span>
  </section>
</template> 
<script>
export default {
  name: "CallSearching",
  props:{
    internetDisconnect: Boolean
  },
  methods:{
      Close(){
          this.$emit('close')
      } 
  },
  mounted(){}
 
}
</script>